import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/location/emptyGeofence.svg'
import _imports_1 from '../../assets/location/serachIcon.svg'
import _imports_2 from '@/assets/location/loIcon.svg'
import _imports_3 from '@/assets/location/down.svg'
import _imports_4 from '@/assets/location/more.svg'
import _imports_5 from '@/assets/location/edit.svg'
import _imports_6 from '@/assets/location/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-f65bceb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locationPage" }
const _hoisted_2 = { class: "locationContent" }
const _hoisted_3 = {
  name: "first",
  lazy: true,
  style: {"height":"calc(100% - 68px)","overflow":"scroll"},
  class: "first"
}
const _hoisted_4 = ["infinite-scroll-disabled"]
const _hoisted_5 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_6 = { class: "skeleton" }
const _hoisted_7 = { class: "skeletonItemWrapper" }
const _hoisted_8 = { class: "skTop" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "hoverContact" }
const _hoisted_11 = { class: "leftInfo" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "itemInfo" }
const _hoisted_14 = { class: "infoDetail" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "detail" }
const _hoisted_17 = ["element-loading-text"]
const _hoisted_18 = {
  key: 0,
  class: "noMore"
}
const _hoisted_19 = {
  key: 2,
  class: "empty"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "empty-text" }
const _hoisted_22 = { class: "createGeofenceBox" }
const _hoisted_23 = { class: "boxItem" }
const _hoisted_24 = { class: "itemTitle" }
const _hoisted_25 = { class: "boxItem" }
const _hoisted_26 = { class: "itemTitle" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "iconSearch"
}, null, -1))
const _hoisted_28 = { class: "custom-option" }
const _hoisted_29 = {
  class: "option-label",
  style: {"font-weight":"700"}
}
const _hoisted_30 = { class: "option-label" }
const _hoisted_31 = { class: "boxItem" }
const _hoisted_32 = { class: "itemTitle" }
const _hoisted_33 = { class: "selectBox" }
const _hoisted_34 = { class: "boxItem" }
const _hoisted_35 = { class: "itemTitle" }
const _hoisted_36 = { style: {"padding":"0 20px","line-height":"34px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"356px","height":"1px","background":"#EBEEF5"} }, null, -1))
const _hoisted_38 = {
  class: "boxItem",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_39 = { class: "itemTitle" }
const _hoisted_40 = { class: "itemEmail" }
const _hoisted_41 = { class: "buttomTwoButton" }
const _hoisted_42 = { class: "buttonCreate" }
const _hoisted_43 = { class: "rightMaps" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "leftImg"
}, null, -1))
const _hoisted_45 = { class: "middleSpan" }
const _hoisted_46 = { class: "geoInfoPopUP" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "itemInfo" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_55 = {
  key: 1,
  class: "itemGeo",
  style: {"justify-content":"center"}
}

import { ref, onMounted, computed, watch, reactive, unref, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import emitter from "@/utils/eventBus";
import { gaEvent } from "@/utils/format";
import { ElMessage } from "element-plus";
import { getGeofencApi, getGeofencsApi, deleteGeofencsApi, crossingEventsApi, getLocationApi } from "@/api/devices";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import mapBox from '@/components/mapbox/map.vue'
import Tooltip from "@/components/common/tooltip.vue";
import { dateFormat, dateFormatAm } from "@/utils/format";
import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { numberToString, numberToWeek } from "@/views/screen/component/fomat";
import changeCancel from "@/components/homePage/tabItem/changeCancel.vue";
import type { FormInstance } from "element-plus";
import { jsonDataLocation } from '@/mock/locations.js'
import { jsonGeoFencing, jsonCrossingEvent } from '@/mock/geofence.js'

interface ListItem {
  value: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'geoFencing',
  props: {
  accessTime: {
    type: Array,
  },
  isSync: {
    type: Boolean
  }
},
  emits: ['sendlastTime'],
  setup(__props, { emit: __emit }) {

const props = __props;
const Emits = __emit
const store = useStore();
const { t } = useI18n();
const isVibe = computed(() => !store.state.isVibe);
const formData = ref({
  id: "",
  device_id: "",
  name: "",
  longitude: 0,
  latitude: 0,
  detail: '',
  cycle: 127,
  radius: 1,
  is_send_alarm_email: true
});
const searchText = ref('')
// 定义网络请求的起始时间
let startTime = ref('')
let endTime = ref('')
const showUpdateTime = ref(false)
const deviceId = computed(() => store.state.currentDeviceInfo.id);
const showRightBox = ref(true) //是否展示时间筛选
// Tab1：地图信息的全部内容
const geofenceList = ref([]);//围栏数组
const crossingEventsList = ref([]);//事件数组
const locationsList = ref([])//location数组
let cumulativeContactList: any = [];//围栏数组
let cumulativeEventsList: any = [];//事件数组
let cumulativeLocationsList: any = [];//location数组
const contactPageNum = ref(1); // 页码
let contactPageSize = ref(20); // 一页多少条数据
let noMoreContact = ref(false); // 是否展示没有更多数据文案
let contactGlobalLoading = ref(true);
const contactLoading = ref(false);
const selectMapList = ref([])//查询出来的数组
const selectedOptions = ref([])//每日
const checkAll = ref(true)//每日
const isIndeterminate = ref(false)//每日
const lastUpdateTime = ref(0)//最后更新时间
const lcoationMap = ref([0, 0])//经纬度
const leftChatActive = ref(0);
const isShowGeofenceBox = ref(false) //是否展示新增编辑界面
const cycle = ref(0b0)
const isShowMore = ref(false)//展示编辑和删除
const isShowDia = ref(false)//是否展示弹窗
const isShowDia1 = ref(false)//是否展示弹窗
const currentItem = ref()//当前选中的围栏
const editId = ref('')//编辑围栏的id map页面要用
const messageInfo = ref('')
const isCreate = ref(true)//是否创建围栏 编辑围栏
const isFirst = ref(false)//是否是第一次进入
const isShowCycleError = ref(false)//是否选择了日期
const isShowGeoInfo = ref(false)//是否展示围栏信息弹窗
// 用于显示多重颜色
const colors = ["#F76560", "#4080FF", "#23C343", "#F99057", "#8D4EDA", '#14C9C9', '#FF9A2E', '#E13EDB', '#85B608'];
const bgColors = ["#FFECE8", "#E8F3FF", "#E8FFEA", "#FFF3E8", "#F5E8FF", '#E8FFFB', '#FFF7E8', '#FFE8FB', '#F6FEC3'];
const weekOptions = [
  {
    label: t('famikeep200.Every Monday'),
    value: 0b00100000,
    gtag: 'Every Monday'
  },
  {
    label: t('famikeep200.Every Tuesday'),
    value: 0b00010000,
    gtag: 'Every Tuesday'
  },
  {
    label: t('famikeep200.Every Wednesday'),
    value: 0b00001000,
    gtag: 'Every Wednesday'
  },
  {
    label: t('famikeep200.Every Thursday'),
    value: 0b00000100,
    gtag: 'Every Thursday'
  },
  {
    label: t('famikeep200.Every Friday'),
    value: 0b00000010,
    gtag: 'Every Friday'
  },
  {
    label: t('famikeep200.Every Saturday'),
    value: 0b00000001,
    gtag: 'Every Saturday'
  },
  {
    label: t('famikeep200.Every Sunday'),
    value: 0b01000000,
    gtag: 'Every Sunday'
  },
]

//左侧颜色展示
const getStyle = (index: any) => {
  // 使用取余运算符来选择颜色
  const colorIndex = index % colors.length;
  console.log("colorIndex:", colorIndex, index);

  return { color: colors[colorIndex], backgroundColor: bgColors[colorIndex] };
};
// 全选事件
const handleCheckAllChange = (val: any) => {
  const data = weekOptions.map(item => {
    return item.label
  })
  console.log("val:", val);
  console.log("data:", data);
  console.log("selectedOptions2：", selectedOptions.value);

  (selectedOptions as any).value = val ? data : [];
  isIndeterminate.value = false;
  console.log("selectedOptions.value:", selectedOptions.value);

}
// 下拉框选择事件
const handleSelect = (value: any) => {
  const checkedCount = value.length;
  checkAll.value = checkedCount === weekOptions.length;
  isIndeterminate.value = checkedCount > 0 && checkedCount < weekOptions.length;
  console.log("selectedOptions1：", selectedOptions.value);
}
const contactItemClick = (index: any, item: any) => {
  console.log("item:", item);

  let res: any = geofenceList.value.filter((element: any) => item.geo_fencing_id == element.id)
  console.log("res:", res);
  console.log("geofenceList:", geofenceList.value, item.geo_fencing_id);

  lcoationMap.value[0] = res[0].longitude
  lcoationMap.value[1] = res[0].latitude
  leftChatActive.value = index;
  console.log("leftChatActive:", leftChatActive.value);
  console.log("lcoationMap:", lcoationMap.value);

};
const disabledContactScroll = computed(
  () => contactLoading.value || noMoreContact.value
);

// 五分钟定时更新
let closeFiveM: any
if (!isVibe.value) {
  closeFiveM = setInterval(async () => {
    contactPageNum.value = 1
    crossingEventsList.value = []
    geofenceList.value = []
    cumulativeEventsList = []
    cumulativeContactList = []
    await getGeofencFun()
    await getCrossingEventsFun()
    await getLocationFun()
  }, 1000 * 60 * 5);
}

// 设置新的定时器
const setNewInterval = () => {
  closeFiveM = setInterval(async () => {
    contactPageNum.value = 1
    crossingEventsList.value = []
    geofenceList.value = []
    cumulativeEventsList = []
    cumulativeContactList = []

    await getGeofencFun()
    await getCrossingEventsFun()
    await getLocationFun()
  }, 1000 * 60 * 5);
}
//获取围栏 isFromScroll是否是无限滚动触底时触发的
const getGeofencFun = async (isFromScroll: boolean = false, isSync?: boolean) => {
  // 调用接口获取聊天记录,获取一页的数据
  // console.log(isFromScroll, 'isFromScroll');
  // console.log('isFromScroll:', props.accessTime![0]);
  if (isVibe.value) {
    geofenceList.value = jsonGeoFencing.data.data.geo_fencings
    if (isFirst.value) return
    gaEvent("Geofence_PV", {
      event_category: "Geofence",
      event_label: geofenceList.value.length > 0 ? 'Data' : 'NoData',
    });
    gaEvent("Geofence_Amount", {
      event_category: "Geofence",
      event_label: geofenceList.value.length,
    });
    isFirst.value = true
    return
  }
  try {
    let onePageContactList: any = [];
    let params = {}
    if (!isVibe.value) {
      params = {
        device_id: deviceId.value,
        start_date: startTime.value,
        end_date: endTime.value,
        page: contactPageNum.value
      }
    } else {
      params = {
        device_id: deviceId.value,
        start_date: 1,
        end_date: 2195740800,
        page: contactPageNum.value
      }
    }
    let res: any;
    console.log('getGeofencFun执行');
    const chatListSourceRef = computed(() => store.state.chatListSource);
    // 取消掉上一次请求
    chatListSourceRef.value &&
      chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    res = await getGeofencApi(params);
    if (res.data.code == 200) {
      console.log("lastUpdateTime:", lastUpdateTime.value);
      if (isSync) {
        console.log("怎么跑来同步了");
        cumulativeContactList = []
        gaEvent("Geofence_Sync", {
          event_category: "Geofence",
          event_label: 'Success',
        });
      }
      // lastUpdateTime.value = res.data.data.update_time
      // Emits('sendlastTime', lastUpdateTime.value)
      console.log("-=-=-=-=-=");

      onePageContactList = res.data.data.geo_fencings || [];
      console.log('contactGlobalLoading.value', contactGlobalLoading.value);
      onePageContactList.map((item: any) => item.isShowMore = false)
      contactGlobalLoading.value = false;
      cumulativeContactList =
        cumulativeContactList.concat(onePageContactList);
      cumulativeContactList.forEach((element: any, index: any) => {
        element.loIndex = index + 1
        let color = getStyle(index)
        element.color = color
      });
      geofenceList.value = cumulativeContactList;
      // if (!localStorage.getItem('Geofence_Amount') || localStorage.getItem('Geofence_Amount') != cumulativeContactList.length) {

      // }
      // localStorage.setItem('Geofence_Amount', cumulativeContactList.length)
      console.log("geofenceList.value：", geofenceList.value);
      console.log("是否第一次进入：", isFirst.value);
      if (isFirst.value) return
      gaEvent("Geofence_PV", {
        event_category: "Geofence",
        event_label: geofenceList.value.length > 0 ? 'Data' : 'NoData',
      });
      gaEvent("Geofence_Amount", {
        event_category: "Geofence",
        event_label: geofenceList.value.length,
      });
      isFirst.value = true
      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }
  } catch (err) {
    console.log(err);
    contactGlobalLoading.value = false;
    // emitter.emit('closeLoading')
    if (isSync) {
      gaEvent("Geofence_Sync", {
        event_category: "Geofence",
        event_label: 'Fail',
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }
    emitter.emit("closeChatLoading");
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    })
    // emitter.emit('closeChatLoading')
  }
  // }
};
//获取事件
const getCrossingEventsFun = async (isFromScroll: boolean = false, isSync?: boolean, isCreateLo: boolean = false) => {
  // 调用接口获取聊天记录,获取一页的数据
  if (isVibe.value) {
    crossingEventsList.value = jsonCrossingEvent.data.data.events
    return
  }
  try {
    let onePageContactList: any = [];
    let params = {}
    params = {
      device_id: deviceId.value,
      begin_at: startTime.value,
      end_at: endTime.value,
      page: contactPageNum.value
    }

    let res: any;
    console.log('getCrossingEventsFun执行');
    const chatListSourceRef = computed(() => store.state.chatListSource);
    // 取消掉上一次请求
    chatListSourceRef.value &&
      chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    res = await crossingEventsApi(params);
    if (res.data.code == 200) {
      console.log("lastUpdateTime:", lastUpdateTime.value);
      if (isCreateLo) {
        //如果要创建围栏
        cumulativeEventsList = []
      } else if (isSync) {
        //如果是同步的
        cumulativeEventsList = []
        if (lastUpdateTime.value == res.data.data.update_time) {
          //更新时间一样的话就没新数据
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
      }
      lastUpdateTime.value = res.data.data.update_time
      console.log("lastUpdateTime.valuelastUpdateTime.valuelastUpdateTime.value：", lastUpdateTime.value);
      if (lastUpdateTime.value) {
        showUpdateTime.value = true
      } else {
        showUpdateTime.value = false
      }
      Emits('sendlastTime', lastUpdateTime.value)
      console.log("-=-=-=-=-=::::::::::", geofenceList.value);

      onePageContactList = res.data.data.events || [];
      console.log('contactGlobalLoading.value', contactGlobalLoading.value);
      console.log('onePageContactList.value', onePageContactList);
      onePageContactList.map((item: any) => item.isShowMore = false)
      contactGlobalLoading.value = false;
      cumulativeEventsList =
        cumulativeEventsList.concat(onePageContactList);
      cumulativeEventsList.forEach((element: any, index: any) => {
        let res: any = geofenceList.value.filter((item: any) => item.id == element.geo_fencing_id)
        element.loIndex = res[0].loIndex
        element.color = res[0].color
        element.isShowMore = false
      });
      if (geofenceList.value.length > 0) isShowGeoInfo.value = true
      crossingEventsList.value = cumulativeEventsList;
      // if (!isFromScroll) {
      //   lcoationMap.value[0] = cumulativeEventsList[0].longitude
      //   lcoationMap.value[1] = cumulativeEventsList[0].latitude
      // }
      console.log("crossingEventsList.value：", crossingEventsList.value);
      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }
  } catch (err) {
    console.log(err);
    contactGlobalLoading.value = false;
    // emitter.emit('closeLoading')
    emitter.emit("closeChatLoading");
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    })
    // emitter.emit('closeChatLoading')
  }
  // }
};
//获取location地理位置 isFromScroll是否是无限滚动触底时触发的
const getLocationFun = async (isFromScroll: boolean = false, isSync?: boolean) => {
  // 调用接口获取聊天记录,获取一页的数据
  if (isVibe.value) {
    locationsList.value = jsonDataLocation.data.locations
    lcoationMap.value[0] = locationsList.value[0].longitude
    lcoationMap.value[1] = locationsList.value[0].latitude
    contactGlobalLoading.value = false;
    return
  }
  try {
    let onePageContactList: any = [];
    let params = {}
    params = {
      device_id: deviceId.value,
      start_date: startTime.value,
      end_date: endTime.value,
      page: contactPageNum.value
    }

    let res: any;
    // console.log('getLocationFun执行');
    const chatListSourceRef = computed(() => store.state.chatListSource);
    // 取消掉上一次请求
    chatListSourceRef.value &&
      chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    res = await getLocationApi(params);
    if (res.data.code == 200) {
      console.log("lastUpdateTime:", lastUpdateTime.value);
      if (isSync) {
        cumulativeLocationsList = []
      }
      onePageContactList = res.data.data.locations || [];
      cumulativeLocationsList =
        cumulativeLocationsList.concat(onePageContactList);
      locationsList.value = cumulativeLocationsList;
      if (locationsList.value.length > 0) {
        if (lcoationMap.value[0] == cumulativeLocationsList[0].longitude && lcoationMap.value[1] == cumulativeLocationsList[0].latitude) {
          lcoationMap.value[0] = cumulativeLocationsList[0].longitude + 0.00000000000001
        } else {
          lcoationMap.value[0] = cumulativeLocationsList[0].longitude
          lcoationMap.value[1] = cumulativeLocationsList[0].latitude
        }
      }

      return new Promise((resolve, reject) => {
        resolve(res.data.data);
      });
    }
  } catch (err) {
    console.log(err);
  }
};
const updateInfo = async () => {
  console.log("点击了同步按钮");

  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  // .value = 1
  contactPageNum.value = 1
  geofenceList.value = []
  crossingEventsList.value = []
  cumulativeEventsList = []
  cumulativeContactList = []
  await getGeofencFun(false, true)
  await getCrossingEventsFun(false, true)
  await getLocationFun(false, true)
}
const loadMoreContactList = () => {
  if (isVibe.value) return
  contactLoading.value = true;
  setTimeout(async () => {
    // console.log("loadMoreContactList");
    contactPageNum.value++;
    const res: any = await getCrossingEventsFun(true);
    // const res: any = await getGeofencFun(true);
    // const total = res.total;
    contactLoading.value = false;
    if (!res.locations) {
      // 如果当前列表总长度大于等于接口返回的数据总长度，则显示没有更多数据文案
      noMoreContact.value = true;
    }
  }, 100);
};
//接收到的时间
const updateHeaderDate = async (value: any) => {
  startTime.value = value[0]
  endTime.value = value[1]
  contactPageNum.value = 1
  geofenceList.value = []
  crossingEventsList.value = []
  cumulativeEventsList = []
  cumulativeContactList = []
  await getGeofencFun()
  await getCrossingEventsFun()
  await getLocationFun()

  console.log('接收到的时间：', startTime.value, endTime.value);
};
//修改搜索地图的文本
const changeSearchText = (e: any) => {
  // console.log("eeeeeeeeeeeeee:", e);
  searchText.value = e
  console.log("searchText:", searchText.value);

}
const selectLocationArray = (e: any) => {
  console.log("selectLocationArray:", e);
  selectMapList.value = e
  console.log("selectMapList:", selectMapList.value);

  options.value = selectMapList.value.filter((item: any) => {
    return item.value
  })
}
const ruleFormRef = ref<FormInstance>();
const handleSelectChange = (e: any) => {
  console.log("handleSelectChange:", e, selectMapList.value);
  // unref 如果参数是一个 ref 则返回它的 value，否则返回参数本身。
  const formRef: any = unref(ruleFormRef);

  formRef.validateField('detail')
  let res: any = selectMapList.value.find((item: any) => item.value === e)
  console.log("res:", res);
  if (res && res.center && res.center.length > 0) {
    lcoationMap.value[0] = res.center[0]
    lcoationMap.value[1] = res.center[1]
  }

  console.log("lcoationMap:", lcoationMap.value);

}
// 点击浮窗之外的地方让浮窗消失
const handleClickOutside = () => {
  console.log("klklklklkl");

  crossingEventsList.value.map((item: any) => {
    item.isShowMore = false
  })
  geofenceList.value.map((item: any) => {
    item.isShowGeoMore = false
  })
};
const selectValue = ref([])
const options = ref<ListItem[]>([])
// const options = ref([])
const loading = ref(false)

const remoteMethod = (query: string) => {
  if (query !== '') {
    loading.value = true
    setTimeout(() => {
      changeSearchText(query)
      loading.value = false
      console.log("options.value:", options.value);

      console.log("selectMapList;", selectMapList.value);
    }, 200)
  } else {
    options.value = []
  }
}
//map传过来的地址
const updateLocationName = (e: any, a: any) => {
  console.log("map传过来的地址:", e, a);
  selectValue.value = e
  formData.value.detail = e
  formData.value.longitude = a[0]
  formData.value.latitude = a[1]

}
//修改fromData的radius
const changeRadius = (num: number) => {
  console.log("changeRadius:", num);

  formData.value.radius = num
}
const saveFromData = () => {
  if (isVibe.value) {
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  checkName()
  checkDetail()
  if (!formData.value.name) {
    return
  }
  if (!formData.value.detail) {
    return
  }
  console.log("formDataformDataformDataformData:", formData.value);

  formData.value.device_id = deviceId.value
  formData.value.cycle = 0b0
  selectedOptions.value.forEach((item: any) => {
    weekOptions.forEach((item2: any) => {
      // console.log('item2',item2,item);
      if (item2.label == item) {
        formData.value.cycle = formData.value.cycle + item2.value
      }
    })
  })
  if (formData.value.cycle == 0) {
    isShowCycleError.value = true
    return
  }
  let tempArr = geofenceList.value
  if (formData.value.id) {//编辑的时候需要把他自己摘出来
    tempArr = geofenceList.value.filter((item: any) => item.id != formData.value.id)
  }
  console.log("tempArr:", tempArr);
  //为了创建围栏的时候判断是否与之前的围栏是否有交集，半径相减，循环上报-------埋点
  tempArr.forEach((item: any, index) => {
    let twolocationM = getDistances(formData.value.latitude, formData.value.longitude, item.latitude, item.longitude)//两地的距离
    console.log("item:", item);
    console.log("twolocationM:", twolocationM);
    console.log("item.radius:", item.radius, formData.value.radius);
    console.log("item.radius + formData.value.radius > twolocationM.m:", item.radius + formData.value.radius > twolocationM.m);
    if (item.radius + formData.value.radius > twolocationM.m) {
      gaEvent("Geofence_Coincide", {
        event_category: "Geofence",
        event_label: 'None',
      });
    }
  })
  getGeofencsApi(formData.value)
    .then(async (res) => {
      // console.log("ressssss:", res);
      selectedOptions.value = []
      const getEditWeek = numberToWeek(formData.value.cycle)
      console.log("getEditWeek:", getEditWeek);
      gaEvent("Geofence_Radius", {
        event_category: "Geofence",
        event_label: `${formData.value.radius}m`,
      });
      gaEvent("Geofence_Date", {
        event_category: "Geofence",
        event_label: getEditWeek,
      });
      gaEvent("Geofence_Alert", {
        event_category: "Geofence",
        event_label: formData.value.is_send_alarm_email ? 1 : 0,
      });
      formData.value = {
        id: "",
        device_id: "",
        name: "",
        longitude: 0,
        latitude: 0,
        detail: '',
        cycle: 0b0,
        radius: 1,
        is_send_alarm_email: false
      }
      isShowGeofenceBox.value = false
      isShowGeoInfo.value = false

      console.log("资料填完了");
      contactPageNum.value = 1
      geofenceList.value = [];
      cumulativeEventsList = []
      crossingEventsList.value = []
      cumulativeContactList = []
      await getGeofencFun()
      await getCrossingEventsFun(false, true, true)
      await getLocationFun()
      isCreate.value = true
    })
    .catch((e) => {
      console.log("e");
      ElMessage({
        message: "资料没填完",
        type: "error",
      });
    })
  console.log("FromData:", formData.value);
}
const cancelFromData = async () => {
  isShowGeofenceBox.value = false
  if (isVibe.value) return
  contactPageNum.value = 1
  geofenceList.value = [];
  cumulativeEventsList = []
  crossingEventsList.value = []
  cumulativeContactList = []
  await getGeofencFun()
  await getCrossingEventsFun(false, true, true)
  await getLocationFun()
  isCreate.value = true
  formData.value = {
    id: "",
    device_id: "",
    name: "",
    longitude: 0,
    latitude: 0,
    detail: '',
    cycle: 0b0,
    radius: 1,
    is_send_alarm_email: true
  }
  const formRef: any = unref(ruleFormRef);
  formRef.resetFields()
}
//更新数据
const updateLaInfo = (item: any, isMap?: boolean) => {
  console.log("item::::::", item);
  console.log("geofenceList.value::::::", geofenceList.value);
  isCreate.value = false //切换成编辑
  let res;
  if (isMap) {
    console.log("地图或者右上方围栏的编辑");
    res = geofenceList.value.filter((element: any) => element.id == item.id)
  } else {
    console.log("事件的编辑");
    res = geofenceList.value.filter((element: any) => element.id == item.geo_fencing_id)
  }
  gaEvent("Geofence_Operate", {
    event_category: "Geofence",
    event_label: 'Edit',
  });
  console.log("resresresres:", res);
  console.log("editId:", editId.value);
  editId.value = res[0].id
  console.log("editId:", editId.value, typeof (editId.value));

  formData.value = res[0]
  selectValue.value = res[0].detail
  console.log("formData.value:", formData.value);

  item.isShowMore = false
  item.isShowGeoMore = false
  const getEditWeek = numberToString(res[0].cycle)
  isShowGeofenceBox.value = true
  selectedOptions.value = getEditWeek
  console.log("updateLaInfores:", res[0]);
  console.log("formData:", formData.value);
}
//删除数据
const deleteLaInfo = (item: any) => {
  console.log("删除item:", item);
  isShowDia.value = true
  currentItem.value = item

}
const deleteFun = () => {
  let params = {
    device_id: deviceId.value
  }
  deleteGeofencsApi(params, currentItem.value.id ? currentItem.value.id : currentItem.value.geo_fencing_id)
    .then(async (res) => {
      // console.log("ressssss:", res);
      isShowGeoInfo.value = false
      contactPageNum.value = 1
      crossingEventsList.value = []
      geofenceList.value = []
      cumulativeEventsList = []
      cumulativeContactList = []
      gaEvent("Geofence_Operate", {
        event_category: "Geofence",
        event_label: 'Delete',
      });
      await getGeofencFun()
      await getCrossingEventsFun()
      await getLocationFun()

      isShowDia.value = false
    })
    .catch((e) => {
      console.log("e");
    })
}
const changeSendAlarm = () => {
  console.log("点击了");
  if (!formData.value.is_send_alarm_email) {
    isShowDia1.value = true
    formData.value.is_send_alarm_email = true
    messageInfo.value = '确定关闭吗？关闭后进入/离开地理围栏您将不会收到电子邮件警报'
  }
}
const changeSendAlarmConfirm = () => {
  isShowDia1.value = false
  formData.value.is_send_alarm_email = false
}
//创建围栏
const clickCreateGeo = () => {
  isShowGeofenceBox.value = true
  selectValue.value = []
  formData.value = {
    id: "",
    device_id: "",
    name: "",
    longitude: 0,
    latitude: 0,
    detail: '',
    cycle: 127,
    radius: 100,
    is_send_alarm_email: true
  }
  const getEditWeek = numberToString(formData.value.cycle)
  // console.log('aaaaa',aaa);
  selectedOptions.value = getEditWeek
  console.log("selectedOptions.value:", selectedOptions.value);
  gaEvent("Geofence_Add", {
    event_category: "Geofence",
    event_label: 'None',
  });
}
//map组件传进来的编辑事件
const editLocationFun = (e: any) => {
  console.log("editLocationFun传进来了:", e);
  updateLaInfo(e, true)
}
//map组件传进来的删除事件
const deleteLocationFun = (e: any) => {
  console.log("deleteLocationFun传进来了:", e);
  currentItem.value = e
  // deleteFun()
  isShowDia.value = true
}
//删除弹窗的文案
const getDeleteInfo = () => {
  console.log("删除的item:", currentItem.value);
  let info = t('famikeep200.Are you sure you want to delete')
  let temp = info.split('xxx')
  let name = currentItem.value.fencing_name ? currentItem.value.fencing_name : currentItem.value.name
  info = temp[0] + name + temp[1]
  console.log("temp:", temp, info);
  return info
}
//计算两个经纬度之间的距离
const getDistances = (lat1: any, lng1: any, lat2: any, lng2: any) => {
  let EARTH_RADIUS = 6378.137;// 地球半径
  let radLat1 = lat1 * Math.PI / 180.0; //lat1 * Math.PI / 180.0=>弧度计算
  let radLat2 = lat2 * Math.PI / 180.0;
  let a = radLat1 - radLat2;
  let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000;// 输出为公里
  return { m: s * 1000, km: Number(s.toFixed(2)) }
}
const emailRule = computed(() => {
  const rule = reactive({
    name: [
      {
        required: true,
        message: t('famikeep200.Please enter a geofence name'),
        trigger: "blur",
      },
    ],
    detail: [
      {
        required: true,
        message: t('famikeep200.Please select a geofence location'),
        trigger: "blur",
      },
    ],
    cycle: [
      {
        required: true,
        message: t('famikeep200.please choose'),
        trigger: "blur",
      },
    ],
  });
  return rule;
});
//校验地理名称
let checkName = () => {
  // unref 如果参数是一个 ref 则返回它的 value，否则返回参数本身。
  const formRef: any = unref(ruleFormRef);
  formRef.validateField("name", (valid: boolean) => {
    if (valid) {
      return true;
    } else {
      return false;
    }
  });
};
//校验地理位置
let checkDetail = () => {
  // unref 如果参数是一个 ref 则返回它的 value，否则返回参数本身。
  const formRef: any = unref(ruleFormRef);
  formRef.validateField("detail", (valid: boolean) => {
    if (valid) {
      return true;
    } else {
      return false;
    }
  });
};
watch(deviceId, async () => {
  contactGlobalLoading.value = true
  if (!isVibe.value) {
    contactPageNum.value = 1
    geofenceList.value = [];
    cumulativeEventsList = []
    crossingEventsList.value = []
    cumulativeContactList = []
    await getGeofencFun()
    await getCrossingEventsFun()
    await getLocationFun()
    clearInterval(closeFiveM);
    setNewInterval()
  } else {
    setTimeout(() => {
      contactGlobalLoading.value = false
    }, 200);
  }

  gaEvent("Geofence_PV", {
    event_category: "Geofence",
    event_label: geofenceList.value.length > 0 ? 'Data' : 'NoData',
  });
  gaEvent("Geofence_Amount", {
    event_category: "Geofence",
    event_label: geofenceList.value.length,
  });

})
// watch(() => props.isSync, () => {
watch(() => [props.accessTime, props.isSync], async (newValue, oldValue) => {
  console.log("监听到了:", props);
  console.log("newValue:", newValue, oldValue);
  if (newValue[1]) {
    geofenceList.value = [];
    cumulativeEventsList = []
    crossingEventsList.value = []
    cumulativeContactList = []
    contactPageNum.value = 1
    await getGeofencFun(false, true)
    await getCrossingEventsFun(false, true)
    await getLocationFun(false, true)
    console.log("状态同步成功");
  } else if (newValue[0] != oldValue[0]) {
    geofenceList.value = [];
    cumulativeEventsList = []
    crossingEventsList.value = []
    cumulativeContactList = []
    contactPageNum.value = 1
    console.log("newValue:", newValue[0], oldValue[0]);
    await getGeofencFun(false)
    await getCrossingEventsFun(false)
    await getLocationFun(false)

    console.log("时间同步成功:");
  }

  contactGlobalLoading.value = false;
}, {
  deep: true
})
const updateNum = () => {
  console.log("formData:", formData.value.radius);
  //@ts-ignore
  if (formData.value.radius === null || formData.value.radius === undefined || formData.value.radius === '') {
    formData.value.radius = 100;
    console.log("formData.value.radius:", formData.value.radius);
  }
}

const showGeoMoreFun = (item: any) => {
  console.log("围栏的更多");
  geofenceList.value.forEach((el: any) => el.isShowGeoMore = false)
  item.isShowGeoMore = true
}
const showGeoInfo = () => {
  isShowGeoInfo.value = !isShowGeoInfo.value
}
const goGeofenceFun = (item: any) => {
  console.log("itemitemitemitem:", item);
  lcoationMap.value[0] = item.lnglat[0]
  lcoationMap.value[1] = item.lnglat[1]
}
onMounted(async () => {
  // 首次渲染页面时，将列表中的第一项数据放进clickMailItemDetail
  if (isVibe.value) {
    contactPageNum.value = 1
    contactPageNum.value = 1
    geofenceList.value = [];
    cumulativeEventsList = []
    crossingEventsList.value = []
    cumulativeContactList = []

    await getGeofencFun()
    await getCrossingEventsFun()
    await getLocationFun()
  } else {
    contactGlobalLoading.value = true;

  }

});
onUnmounted(() => {
  clearInterval(closeFiveM);
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(publicHeader, {
        headerName: _ctx.$t('famikeep200.Geofence'),
        showUpdateTime: showUpdateTime.value,
        headerSyncDate: lastUpdateTime.value,
        headerSelectData: [],
        onUpdateHeaderDate: updateHeaderDate,
        onUpdateInfo: updateInfo,
        showRightBox: showRightBox.value
      }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate", "showRightBox"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["leftTabs", crossingEventsList.value.length && crossingEventsList.value.length > 0 ? '' : 'isNoData'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledContactScroll.value,
              "infinite-scroll-distance": "1",
              style: {"overflow-y":"auto","overflow-x":"hidden","height":"100%"},
              class: "leftList"
            }, [
              (_unref(contactGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _unref(contactGlobalLoading),
                      animated: true,
                      count: 9
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"85%"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : (crossingEventsList.value.length && crossingEventsList.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crossingEventsList.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["infoItem pointer", leftChatActive.value == index ? 'selected' : '']),
                              onClick: ($event: any) => (contactItemClick(index, item))
                            }, [
                              _createElementVNode("div", {
                                class: "circleIndex",
                                style: _normalizeStyle(item.color)
                              }, _toDisplayString(item.loIndex), 5),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(Tooltip, {
                                      content: item.fencing_name
                                    }, null, 8, ["content"])
                                  ])
                                ]),
                                _createElementVNode("p", _hoisted_16, [
                                  _createVNode(Tooltip, {
                                    content: `${isVibe.value ? _unref(dateFormatAm)(item.date, 'YYYY-MM-DD HH:mm:ss') : _unref(dateFormat)(item.date, 'YYYY-MM-DD HH:mm:ss')} ${item.type == 1 ? _ctx.$t('famikeep200.Entered') : _ctx.$t('famikeep200.Exited')} ${item.fencing_name}`
                                  }, null, 8, ["content"])
                                ])
                              ])
                            ], 10, _hoisted_12))
                          }), 256))
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", {
                        "element-loading-text": _ctx.$t('chat.loadingText'),
                        style: _normalizeStyle({ 'margin-top': contactLoading.value ? '40px' : '10px' })
                      }, null, 12, _hoisted_17), [
                        [_directive_loading, contactLoading.value]
                      ]),
                      (_unref(noMoreContact))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (!_unref(contactGlobalLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('famikeep200.Create a geofence')), 1),
                        _createElementVNode("div", {
                          class: "emptyGeoButtom pointer",
                          onClick: clickCreateGeo
                        }, _toDisplayString(_ctx.$t('famikeep200.Create a new geofence')), 1)
                      ]))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_4)), [
              [_directive_infinite_scroll, loadMoreContactList]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_form, {
                rules: emailRule.value,
                model: formData.value,
                ref_key: "ruleFormRef",
                ref: ruleFormRef,
                "inline-message": "true",
                "scroll-to-error": "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('famikeep200.Geofence name')), 1),
                        _createVNode(_component_el_input, {
                          modelValue: formData.value.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                          placeholder: _ctx.$t('famikeep200.Please enter a geofence name'),
                          class: "inputStyle",
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "detail"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('famikeep200.Set geofence location')), 1),
                        _createVNode(_component_el_select_v2, {
                          modelValue: formData.value.detail,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.detail) = $event)),
                          filterable: "",
                          remote: "",
                          "popper-class": "selectCls",
                          "remote-method": remoteMethod,
                          clearable: "",
                          options: options.value,
                          loading: loading.value,
                          placeholder: _ctx.$t('famikeep200.Please select a geofence location'),
                          onChange: handleSelectChange
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_27
                          ]),
                          default: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(item.text), 1),
                              _createElementVNode("p", _hoisted_30, _toDisplayString(item.label), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "loading", "placeholder"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "radius"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('famikeep200.Set radius')) + "(m)", 1),
                        _createVNode(_component_el_input_number, {
                          modelValue: formData.value.radius,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.radius) = $event)),
                          class: "mx-4",
                          min: 1,
                          "controls-position": "right",
                          onBlur: updateNum
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", {
                            class: "pointer itemBox",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeRadius(50)))
                          }, "50m"),
                          _createElementVNode("div", {
                            class: "pointer itemBox",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeRadius(150)))
                          }, "150m"),
                          _createElementVNode("div", {
                            class: "pointer itemBox",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeRadius(500)))
                          }, "500m"),
                          _createElementVNode("div", {
                            class: "pointer itemBox",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (changeRadius(1000)))
                          }, "1000m")
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "cycle"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('famikeep200.Set monitoring time')), 1),
                        _createVNode(_component_el_select, {
                          multiple: "",
                          clearable: "",
                          modelValue: selectedOptions.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedOptions).value = $event)),
                          placeholder: _ctx.$t('famikeep200.please choose'),
                          onChange: handleSelect,
                          onBlur: handleSelect
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_el_checkbox, {
                                indeterminate: isIndeterminate.value,
                                modelValue: checkAll.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((checkAll).value = $event)),
                                onChange: handleCheckAllChange,
                                class: "checkboxStyle",
                                style: {"display":"flex","flex-direction":"row-reverse","align-items":"center","justify-content":"space-between","padding-right":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('famikeep200.Daily')), 1)
                                ]),
                                _: 1
                              }, 8, ["indeterminate", "modelValue"]),
                              _hoisted_37
                            ]),
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: selectedOptions.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedOptions).value = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekOptions, (item) => {
                                  return _createVNode(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.label
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_checkbox, {
                                        class: "checkboxStyle",
                                        style: {"pointer-events":"none","display":"flex","flex-direction":"row-reverse","align-items":"center","justify-content":"space-between"},
                                        label: item.label
                                      }, null, 8, ["label"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"]),
                        _withDirectives(_createElementVNode("p", { class: "errorP" }, _toDisplayString(_ctx.$t('famikeep200.please choose')), 513), [
                          [_vShow, isShowCycleError.value]
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    prop: "is_send_alarm_email"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('famikeep200.Send alerts via email')), 1),
                          _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t('famikeep200.We will send alert emails to the registered email')), 1)
                        ]),
                        _createVNode(_component_el_switch, {
                          modelValue: formData.value.is_send_alarm_email,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.is_send_alarm_email) = $event)),
                          size: "large",
                          style: {"--el-switch-on-color":"#67C23A","--el-switch-off-color":"#c9cdd4"},
                          onChange: changeSendAlarm
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model"]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: "itemButton left pointer",
                  onClick: saveFromData
                }, _toDisplayString(_ctx.$t('famikeep200.Save')), 1),
                _createElementVNode("div", {
                  class: "itemButton right pointer",
                  onClick: cancelFromData
                }, _toDisplayString(_ctx.$t('famikeep200.Back')), 1)
              ])
            ], 512), [
              [_vShow, isShowGeofenceBox.value]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              class: "emptyGeoButtom pointer",
              onClick: clickCreateGeo
            }, _toDisplayString(_ctx.$t('famikeep200.Create a new geofence')), 1)
          ], 512), [
            [_vShow, crossingEventsList.value && crossingEventsList.value.length > 0]
          ])
        ], 2),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", {
            class: "selectTop pointer",
            onClick: showGeoInfo
          }, [
            _hoisted_44,
            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('famikeep210.Created geofences')), 1),
            _createElementVNode("img", {
              src: _imports_3,
              alt: "",
              class: _normalizeClass(["rightImg", isShowGeoInfo.value ? 'rotate' : ''])
            }, null, 2)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_46, [
            (geofenceList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(geofenceList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "itemGeo pointer",
                      onClick: ($event: any) => (goGeofenceFun(item))
                    }, [
                      _createElementVNode("div", {
                        style: _normalizeStyle({ 'background': item.color.backgroundColor, 'color': item.color.color }),
                        class: "itemCircle"
                      }, _toDisplayString(item.loIndex), 5),
                      _createElementVNode("span", _hoisted_49, [
                        _createVNode(Tooltip, {
                          content: item.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]),
                      _createElementVNode("img", {
                        src: _imports_4,
                        alt: "",
                        onClick: _withModifiers(($event: any) => (showGeoMoreFun(item)), ["stop"]),
                        class: "pointer"
                      }, null, 8, _hoisted_50),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["moreGeoBox", isVibe.value ? 'demoStyle' : ''])
                      }, [
                        _createElementVNode("div", {
                          class: "moreItem pointer",
                          onClick: _withModifiers(($event: any) => (updateLaInfo(item, true)), ["stop"])
                        }, [
                          _hoisted_52,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Edit')), 1)
                        ], 8, _hoisted_51),
                        _createElementVNode("div", {
                          class: "moreItem pointer",
                          onClick: _withModifiers(($event: any) => (deleteLaInfo(item)), ["stop"])
                        }, [
                          _hoisted_54,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Delete')), 1)
                        ], 8, _hoisted_53)
                      ], 2)), [
                        [_vShow, item.isShowGeoMore],
                        [_directive_click_outside, handleClickOutside]
                      ])
                    ], 8, _hoisted_48))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.$t('famikeep210.No geofences created')), 1))
          ], 512), [
            [_vShow, isShowGeoInfo.value]
          ]),
          _createVNode(mapBox, {
            lcoationMap: lcoationMap.value,
            functionPage: 'geofencing',
            searchText: searchText.value,
            locationRadius: formData.value.radius,
            geofenceList: geofenceList.value,
            isCreate: isCreate.value,
            editId: editId.value,
            onSelectLocationArray: selectLocationArray,
            onUpdateLocationName: updateLocationName,
            onEditLocationFun: editLocationFun,
            onDeleteLocationFun: deleteLocationFun
          }, null, 8, ["lcoationMap", "searchText", "locationRadius", "geofenceList", "isCreate", "editId"])
        ])
      ])
    ]),
    (isShowDia.value)
      ? (_openBlock(), _createBlock(changeCancel, {
          key: 0,
          visible: isShowDia.value,
          showTitle: false,
          showclose: false,
          width: 480,
          info: getDeleteInfo(),
          onConfirm: _cache[11] || (_cache[11] = ($event: any) => (isShowDia.value = false)),
          onCancle: deleteFun,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('famikeep200.Back')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (isShowDia1.value)
      ? (_openBlock(), _createBlock(changeCancel, {
          key: 1,
          visible: isShowDia1.value,
          showTitle: false,
          showclose: false,
          width: 480,
          info: _ctx.$t('famikeep200.Are you sure you want to close'),
          onConfirm: _cache[12] || (_cache[12] = ($event: any) => (isShowDia1.value = false)),
          onCancle: changeSendAlarmConfirm,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('famikeep200.Back')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})